document.addEventListener('DOMContentLoaded', function() {
    const faqGroups = document.querySelectorAll('.accordion-faqs-group');

    const searchField = document.querySelector('.js-searchbar-field');
    const clearButton = document.querySelector('.js-clear-button');

    searchField.addEventListener('input', function() {
        const searchTerm = this.value.trim().toLowerCase();

        if (searchTerm.length >= 2) {
            faqGroups.forEach((faqGroup) => {
                const faqs = faqGroup.querySelectorAll('.accordion-item');
                let groupHasMatch = false;

                faqs.forEach((faq) => {
                    const question = faq.querySelector('.accordion .question').textContent.toLowerCase();

                    if (question.includes(searchTerm)) {
                        faq.style.display = 'block'; // Show matching FAQ
                        groupHasMatch = true;
                    } else {
                        faq.style.display = 'none'; // Hide non-matching FAQ
                    }
                });

                // Show or hide the FAQ group based on whether it has matching FAQs
                if (groupHasMatch) {
                    faqGroup.classList.add('active');
                } else {
                    faqGroup.classList.remove('active');
                }
            });
        } else {
            // If search term is less than 2 characters, reset FAQ groups and items
            faqGroups.forEach((faqGroup) => {
                faqGroup.classList.remove('active');
                const faqs = faqGroup.querySelectorAll('.accordion-item');
                faqs.forEach((faq) => {
                    faq.style.display = 'block';
                });
            });
        }
    });

    clearButton.addEventListener('click', function() {
        searchField.value = '';
        document.querySelector('.faqs .accordion-faqs-tabs .tab.active').click();

        faqGroups.forEach((faqGroup) => {
            const faqs = faqGroup.querySelectorAll('.accordion-item');
            faqs.forEach((faq) => {
                faq.style.display = 'block';
            });
        });
    });
});